// extracted by mini-css-extract-plugin
export var avatarContainer = "_fl-0";
export var avatarTypingWave = "_fl-i";
export var gray = "_fl-f";
export var green = "_fl-c";
export var icon = "_fl-9";
export var image = "_fl-1";
export var lg = "_fl-6";
export var md = "_fl-5";
export var presenceDot = "_fl-b";
export var red = "_fl-d";
export var sm = "_fl-4";
export var status = "_fl-a";
export var typingDot = "_fl-h";
export var typingPill = "_fl-g";
export var xl = "_fl-7";
export var xs = "_fl-3";
export var xxl = "_fl-8";
export var xxs = "_fl-2";
export var yellow = "_fl-e";